import React from 'react';
import { Button, Segment } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import { clone } from 'ramda';

const ZeroPayment = (props) => {
  const {
    t,
    onSubmit,
    data = []
  } = props;


  const onSubmitZeroPayment = () => {
    onSubmit(clone(data));
  };
  
  return (
    <div>
      <Segment>
        {t('private:zeroPayment.text')}
      </Segment>
      <Button positive content={t('private:zeroPayment.confirm')} onClick={onSubmitZeroPayment}/>
    </div>
  );
};

export default withNamespaces(['private'])(ZeroPayment);



// WEBPACK FOOTER //
// ./src/private/user/components/Payment/Zero/index.js